{
  "errorBoundary": {
    "dashboard": "Toolbox dashboard failed to load.",
    "extractor": "The Model Extractor view failed to load.",
    "extractorRun": "The Model Extractor run view failed to load.",
    "gatekeeper": "The Submission Gatekeeper view failed to load.",
    "gatekeeperRun": "The Submission Gatekeeper run view failed to load.",
    "logicInspector": "The Flaw Hunter view failed to load.",
    "logicInspectorRun": "The Flaw Hunter run view failed to load.",
    "docReviewer": "The Doc Inspector view failed to load.",
    "docReviewerRun": "The Doc Inspector run view failed to load.",
    "codeWalkthrough": "Code Walkthrough failed to load.",
    "codeWalkthroughRun": "Code Walkthrough run failed to load."
  },
  "dashboard": {
    "title": "Available tools",
    "empty": "No tools available.",
    "loading": "Loading…",
    "loadFailedFallback": "Failed to load jobs",
    "activeRuns": "Active runs",
    "activeIdle": "idle",
    "activeRunningSuffix": "running · refresh 4s",
    "tools": "Tools",
    "toolsAvailableLabel": "available",
    "extractorTileName": "Model Extractor",
    "extractorTileCap": "Extracts the complex model logic embedded in an Excel workbook into an asset package — easy to consume for both human reviewers and AI agents.",
    "gatekeeperTileName": "Submission Gatekeeper",
    "gatekeeperTileCap": "Fast intake check on a submission package. Drop in the files (or a whole folder), pair them with a checklist, get a PASS/FAIL verdict and a list of what's missing — before any deep validation begins.",
    "lastUsed": "Last used",
    "open": "Open",
    "flawHunterTileName": "Flaw Hunter",
    "flawHunterTileCap": "Static scan for data-usage + logic antipatterns in model code — Python / R / SAS / SQL / JS / TS / Java / Go / Rust / etc. Use the Model Extractor for Excel models.",
    "docInspectorTileName": "Doc Inspector",
    "docInspectorTileCap": "Single-doc consistency + regulatory-compliance check on third-party model documentation (DOCX / PDF / MD).",
    "recentOutputs": "Recent outputs",
    "recentMetaSuffix": "all your runs · paginated",
    "noCompleted": "No completed runs yet. Drop a workbook into the extractor to get started.",
    "nothingRunning": "Nothing running right now.",
    "table": {
      "tool": "Tool",
      "target": "Target",
      "finished": "Finished",
      "duration": "Duration",
      "output": "Output",
      "openArrow": "Open →"
    },
    "phaseLabel": "Phase",
    "started": "STARTED {{time}}",
    "elapsed": "ELAPSED · {{value}}",
    "queued": "queued",
    "running": "running",
    "codeWalkthroughTileName": "Code Walkthrough",
    "codeWalkthroughTileCap": "Line-anchored review workbook from model code"
  },
  "pagination": {
    "showing": "Showing <0>{{from}}–{{to}}</0> of <1>{{total}}</1>",
    "prev": "‹ Prev",
    "next": "Next ›",
    "loading": "Loading…",
    "loadFailed": "Failed to load runs"
  },
  "extractor": {
    "title": "Extractor",
    "subtitle": "Pull structured data out of spreadsheets and documents.",
    "uploadButton": "Upload file",
    "selectFile": "Select a file to begin.",
    "supportedFormats": "Supports XLSX, CSV, PDF, DOCX.",
    "running": "Running extractor...",
    "complete": "Extraction complete.",
    "failed": "Extraction failed.",
    "downloadResult": "Download result",
    "viewResult": "View result",
    "rerun": "Run again",
    "presetLabel": "2. Select preset",
    "pickWorkbookLabel": "1. Pick workbook",
    "noPreset": "No preset",
    "outputFormat": "Output format",
    "runHistory": "Recent runs",
    "noHistory": "No recent runs.",
    "openRun": "Open run",
    "headline": "Model Extractor",
    "headlineDescription": "Extracts the complex model logic embedded in an Excel workbook — formulas, VBA, pivots, named ranges, dependency graph — into a self-contained asset package that's easy for both human reviewers and AI agents to consume.",
    "toolbox": "Toolbox",
    "runExtraction": "Run extraction",
    "fileBadge": ".xlsx · .xlsm",
    "presetCustom": "custom (manual override)",
    "presetActive": "{{name}}",
    "presetButtons": {
      "highLevel": "High level",
      "highLevelCap": "skim-friendly · pattern detection on",
      "balanced": "Balanced",
      "balancedCap": "sensible default · light post-processing",
      "detailed": "Detailed",
      "detailedCap": "deep on most types · full enumeration"
    },
    "extractionDepth": "3. Configure extraction depth",
    "extractionDepthHint": "raw layer always lossless",
    "rows": {
      "vba": "VBA modules",
      "vbaHelp": "Verbatim source per module. Standard adds procedure index. Deep adds Range/Cells/Sheets interaction extraction.",
      "pivots": "Pivot tables",
      "pivotsHelp": "Configuration at Standard. Deep adds synthesised per-output-cell derivations.",
      "powerQuery": "Power Query (M)",
      "powerQueryHelp": "Verbatim M source per query. Deep adds step-chain parsing.",
      "namedRanges": "Named ranges",
      "namedRangesHelp": "Light = name + raw refers_to. Standard adds resolved cell list. Deep adds per-cell membership records.",
      "conditionalFormatting": "Conditional formatting",
      "conditionalFormattingHelp": "Rules at Standard. Deep adds per-cell membership records.",
      "dataValidation": "Data validation",
      "dataValidationHelp": "Rules at Standard. Standard already includes per-cell membership records.",
      "charts": "Charts",
      "chartsHelp": "Inventory at Light. Standard adds data-series source bindings.",
      "externalLinks": "External links",
      "externalLinksHelp": "Inventory at Light. Standard adds per-cell consumer records."
    },
    "postProcessing": "4. Configure post-processing",
    "postProcessingHint": "narrative + patterns density",
    "aggressiveness": "Aggressiveness",
    "postHelp": {
      "off": "Narrative enumerates 1:1 from raw NDJSON. No patterns. Lossless.",
      "light": "Contiguous identical formulas collapsed into ranges in narrative. Patterns layer not emitted.",
      "standard": "Light + WL pattern detection emits a patterns layer alongside the cells layer.",
      "aggressive": "Standard + per-cell narrative records replaced with \"see pattern P-N\" pointers wherever applicable."
    },
    "ctaInfo": "Runs in your toolbox · <0>async</0> · safe to leave the page.",
    "ctaInfoLine2": "Output downloads as a single zip via a short-lived secure link.",
    "starting": "Starting…",
    "runExtractionButton": "Run extraction",
    "unsupportedFormat": "Unsupported format: .{{ext}}. Only .xlsx and .xlsm are accepted.",
    "whatProduces": "What this produces",
    "bundleAnatomy": "Bundle anatomy",
    "fileTreeRoot": "bundle.zip ({jobid}.zip)",
    "fileLabel_one": "{{count}} file",
    "fileLabel_other": "{{count}} files",
    "recentRuns": "Recent runs",
    "recentMetaSuffix": "· this tool only · refresh 4s",
    "noRecentForTool": "No completed runs yet.",
    "tableHeaders": {
      "target": "Target",
      "finished": "Finished",
      "duration": "Duration",
      "bundle": "Bundle"
    },
    "tips": "Tips",
    "tipsItems": {
      "deterministicTitle": "Deterministic",
      "deterministicBody": "The same workbook always produces the same bundle.",
      "formatsTitle": ".xlsx / .xlsm only",
      "formatsBody": "Older <0>.xls</0> / <1>.xlsb</1> and password-protected workbooks raise a typed error; strip the password first.",
      "rawTitle": "Raw layer always lossless",
      "rawBody": "Post-processing changes only the narrative and pattern layers; the cell-level records are always kept in full.",
      "pivotTitle": "Pivot derivations at Deep",
      "pivotBody": "Each pivot output cell becomes a self-contained SUMIFS-equivalent expression at <0>pivots = deep</0>.",
      "scaleTitle": "Hundreds of thousands of cells fine",
      "scaleBody": "Large workbooks produce larger bundles and download without an upload timeout."
    },
    "dropZone": {
      "drop": "Drop a workbook here",
      "or": "<0>.xlsx</0> or <1>.xlsm</1> · click to browse",
      "replace": "Replace",
      "ready": "ready to extract"
    },
    "depthLabels": {
      "off": "Off",
      "light": "Light",
      "standard": "Standard",
      "deep": "Deep",
      "forensic": "Forensic",
      "aggressive": "Aggressive"
    },
    "bundleCategories": {
      "index": "Index",
      "corpus": "Corpus (RAG markdown)",
      "archive": "Archive (zstd NDJSON)",
      "narrative": "Narrative markdown",
      "audit": "Audit"
    },
    "anatomy": {
      "workbookOverview": {
        "title": "Workbook overview",
        "description": "sheet inventory, calc settings"
      },
      "inputs": {
        "title": "Inputs",
        "description": "leaf cells the model depends on"
      },
      "cycles": {
        "title": "Cycles",
        "description": "iterative-calc dependencies (if present)"
      },
      "namedRanges": {
        "title": "Named ranges",
        "description": "workbook + sheet-scoped names"
      },
      "tables": {
        "title": "Tables",
        "description": "Excel structured tables"
      },
      "formulas": {
        "title": "Formulas",
        "description": "topo-ordered, per-sheet"
      },
      "pivots": {
        "title": "Pivots",
        "descriptionConfigs": "configurations",
        "descriptionDeep": "configs + flattened derivations"
      },
      "powerQuery": {
        "title": "Power Query",
        "description": "M source per query"
      },
      "vba": {
        "title": "VBA",
        "descriptionVerbatim": "modules verbatim",
        "descriptionStandard": "modules + procedure index",
        "descriptionDeep": "modules + procedure index + interactions"
      },
      "charts": {
        "title": "Charts",
        "descriptionInventory": "inventory",
        "descriptionSeries": "inventory + series sources"
      },
      "conditionalFormatting": {
        "title": "Conditional formatting",
        "descriptionRules": "rules",
        "descriptionDeep": "rules + per-cell membership"
      },
      "dataValidation": {
        "title": "Data validation",
        "description": "rules + per-cell membership"
      },
      "externalLinks": {
        "title": "External links",
        "description": "workbook references"
      },
      "patterns": {
        "title": "Patterns",
        "description": "WL-signature formula collapse"
      }
    }
  },
  "extractorRun": {
    "loading": "Loading job…",
    "failedToLoad": "Failed to load job",
    "failedToCancel": "Failed to cancel job",
    "cancelling": "Cancelling…",
    "cancelRun": "Cancel run",
    "backToToolbox": "← Back to Toolbox",
    "runAnother": "Run another →",
    "presetLabel": "preset",
    "postLabel": "post",
    "sheetCount": "{{count}} sheets",
    "pipeline": "Extracting model",
    "statusLabel": "Completed",
    "starting": "starting",
    "failedStatus": "failed",
    "awaitingPlan": "Awaiting the execution plan…",
    "counters": "Counters",
    "runMarkedStaleTitle": "Run marked stale",
    "runMarkedStaleBody": "No progress signal arrived for this run within the expected window, so it was closed without a result. Try again.",
    "runCancelled": "This run was cancelled.",
    "runComplete": "Run complete.",
    "completeStats": {
      "totalTime": "Total time",
      "bundle": "Bundle",
      "formulas": "Formulas",
      "edges": "Edges"
    },
    "bundleContents": "Bundle contents",
    "exportToWorkspace": "Export to workspace",
    "downloadBundle": "Download bundle",
    "downloadBundleWithSize": "Download bundle · {{size}} KB",
    "preparing": "Preparing…",
    "runFailedTitle": "This extraction did not complete",
    "runFailedNote": "The run stopped before it produced an asset package, so nothing can be reported about this workbook. Run it again, and quote run {{jobId}} if it happens twice.",
    "noDetail": "No detail provided",
    "manifestNotAvailable": "Bundle manifest not yet available — refresh in a moment.",
    "headline": "Model Extractor",
    "stats": {
      "sheet_count": "Sheets",
      "cell_count": "Cells",
      "formula_cell_count": "Formulas",
      "named_range_count": "Named ranges",
      "table_count": "Tables",
      "pivot_count": "Pivots",
      "power_query_count": "Power Query",
      "vba_module_count": "VBA modules",
      "vba_procedure_count": "VBA procedures",
      "conditional_formatting_rule_count": "CF rules",
      "data_validation_rule_count": "DV rules",
      "chart_count": "Charts",
      "chart_series_count": "Chart series",
      "external_link_count": "External links",
      "graph_node_count": "Graph nodes",
      "graph_edge_count": "Graph edges",
      "cycle_count": "Cycles",
      "pivot_cell_count": "Pivot derivations",
      "named_range_member_count": "NR members",
      "cf_membership_count": "CF members",
      "dv_membership_count": "DV members",
      "vba_interaction_count": "VBA interactions",
      "pattern_count": "Patterns",
      "warning_count": "Warnings"
    },
    "exportTitleLabel": "Extractor"
  },
  "gatekeeperRun": {
    "exportTitleLabel": "Submission Gatekeeper"
  },
  "common": {
    "loading": "Loading...",
    "loadFailed": "Could not load.",
    "tryAgain": "Try again",
    "attachContextDocument": "Attach context document",
    "deleteRun": "Delete this run",
    "deleteRunTitle": "Delete this run?",
    "deleteRunBody": "This permanently removes the run record and every artifact it produced (source file, outputs, charts). It cannot be undone.",
    "deleteRunConfirm": "Delete",
    "deleteRunDeleting": "Deleting…",
    "deleteRunFailed": "Delete failed",
    "cancel": "Cancel",
    "close": "Close",
    "refresh": "Refresh",
    "running": "Running",
    "runAnother": "Run another",
    "runFailed": "Run failed",
    "failedChip": "failed",
    "dismiss": "Dismiss",
    "noRunsYet": "No runs yet",
    "pastRunsHint": "Past runs will appear here after they finish.",
    "stale": "Stale",
    "cancelled": "Cancelled",
    "interrupted": "Interrupted",
    "runInterruptedTitle": "Run interrupted",
    "runInterruptedBody": "This run ended early because the service it was running on shut down. It produced no result — start a new run to try again.",
    "discard": "Discard",
    "downloading": "Downloading…",
    "download": "Download",
    "viewFull": "View full",
    "preparingZip": "Preparing zip…",
    "loadingJob": "Loading job…",
    "loadingJobHint": "Fetching the inspection job state.",
    "errorBackToToolbox": "Back to Toolbox",
    "parentModelArchived": "This model is archived. New runs and exports to a project are off; everything this model already produced stays listed and downloadable.",
    "parentModelMissing": "Open the Toolbox from a model to start a new run."
  },
  "logicInspector": {
    "title": "Flaw Hunter",
    "subtitle": "Static scan for data-usage + logic antipatterns in model code — Python / R / SAS / SQL / JS / TS / Java / Go / Rust.",
    "intro": "Drop in model code — Python / R / SAS / SQL / JS / TS / Java / Go / Rust / etc. Excel workbooks aren't supported here; use the <strong>Model Extractor</strong> tool first if your model lives in Excel. The bundle stays in your Toolbox; nothing is auto-imported into a workspace.",
    "stepPickFiles": "1. Pick files",
    "filePickerHint": "Any text or code file — Python, R, SAS, SQL, JS, TS and more. Excel goes to the Model Extractor.",
    "stepPickCategories": "2. Pick categories",
    "categoriesHint": "Disabled categories produce zero findings even when the bundle contains them.",
    "addCustomCheck": "Add a custom check…",
    "customCheckPlaceholder": "e.g. \"flag any model that fits without setting random.seed\"",
    "submitting": "Submitting…",
    "submittingHint": "Queueing the inspection job.",
    "runCta": "Run Flaw Hunter",
    "recentRuns": "Recent runs",
    "noCompletedRuns": "No completed runs yet.",
    "colTarget": "Target",
    "colFindings": "Findings",
    "colCategories": "Categories",
    "colFinished": "Finished",
    "colDuration": "Duration",
    "colStatus": "Status",
    "huntingFlaws": "Hunting flaws",
    "huntingFlawsHint": "Status: {{status}}…",
    "runFailedTitle": "This inspection did not complete",
    "runFailedNote": "The run stopped before it produced findings, so nothing can be reported about this code — not even that it is clean. Run it again, and quote run {{jobId}} if it happens twice.",
    "inspectionComplete": "Inspection complete",
    "completed": "Completed",
    "findingsCount_one": "{{count}} finding",
    "findingsCount_other": "{{count}} findings",
    "categoriesEnabled": "{{count}} categories enabled",
    "exportToWorkspace": "Export to workspace",
    "noFindingsDetected": "No findings detected."
  },
  "docReviewer": {
    "title": "Doc Inspector",
    "subtitle": "Single-doc consistency + regulatory-compliance check on third-party model documentation.",
    "intro": "Upload a model-documentation artifact (.docx · .pdf · .md · .txt · .rst). The document type is <strong>optional</strong>: pick one to add a regulatory pass scoped to that curated knowledge, or leave it unset to run the writing-quality pass alone.",
    "stepPickDocument": "1. Pick document",
    "filePickerHint": "Single document — .docx · .pdf · .md · .txt · .rst.",
    "stepPickTemplate": "2. Add a template or instructions (optional)",
    "templateHint": "Upload the template, required-contents list or instruction document this submission is meant to follow — Bennie derives a requirement checklist from it and scores the document against that checklist. Leave it empty and <strong>no requirement check runs</strong>; the report marks it as not requested.",
    "templateFilePickerHint": "Single document — .docx · .pdf · .md · .txt · .rst.",
    "stepPickDocumentType": "3. Pick document type (optional)",
    "documentTypeHint": "Vertical → document type sets the reference material used for the regulatory pass. Leave it unset and <strong>no regulatory pass runs</strong>; the report marks it as not requested.",
    "selectScopeCta": "Pick document type",
    "editScope": "Edit",
    "clearScope": "Clear",
    "cancelScope": "Cancel",
    "scopeSummary": "Selected: <strong>{{title}}</strong> · Document type: <strong>{{type}}</strong>",
    "submitting": "Submitting…",
    "submittingHint": "Creating the inspection job.",
    "runCta": "Run Doc Inspector",
    "recentRuns": "Recent runs",
    "noCompletedRuns": "No completed runs yet.",
    "colDocument": "Document",
    "colMode": "Mode",
    "colFindings": "Findings",
    "colVerdict": "Verdict",
    "colFinished": "Finished",
    "colStatus": "Status",
    "modeNoDocumentType": "no document type",
    "modeUnreadable": "unreadable",
    "modeUnreadableHint": "This run recorded a result in the current format, but the regulatory section is missing or malformed, so whether a document type was used cannot be established. This is not a clean result.",
    "inspectingDocument": "Inspecting document",
    "runningChecks": "Running the requested checks…",
    "reviewComplete": "Review complete",
    "completed": "Completed",
    "runIncomplete": "Review incomplete",
    "runIncompleteChip": "Did not complete",
    "runIncompleteHeading": "Some checks did not complete",
    "runIncompleteNote": "No overall verdict was reached for this run, so it must not be read as a pass. The checks that did complete are shown below, each with its own result.",
    "runCancelledTitle": "Run cancelled",
    "runCancelledNote": "This run was cancelled before it finished, so no review was produced for this document.",
    "runStaleTitle": "Run marked stale",
    "runStaleNote": "No progress signal arrived for this run within the expected window, so it was closed without a result. Submit the document again.",
    "advisoryPassed": "Ready for downstream use.",
    "advisoryPassedWithIssues": "Send this for a full validation before it is relied on downstream.",
    "advisoryFailed": "Substantial rework needed — re-run before this report is used downstream.",
    "advisoryNotRequestedScope": "{{advisory}} This verdict does not cover the checks that were not requested: {{checks}}.",
    "advisoryScopeSeparator": ", ",
    "validateAction": "Validate",
    "resubmitAction": "Resubmit",
    "downloadReport": "Download report (.docx)",
    "downloadWorkbook": "Download workbook (.xlsx)",
    "internalRegulatoryCount": "{{internal}} internal · {{regulatory}} regulatory",
    "internalCountNoRegulatory": "{{internal}} internal · regulatory not requested",
    "internalInconsistencies": "Internal Inconsistencies",
    "regulatoryNonCompliance": "Regulatory Non-Compliance",
    "regulatoryNotRequestedNote": "Not requested — no document type was selected, so the regulatory check did not run. This is not a clean result.",
    "notRequestedChip": "not requested",
    "noDocumentTypeSelected": "no document type selected",
    "noInternalFindings": "No internal findings.",
    "noRegulatoryFindings": "No regulatory findings.",
    "runnerFailed": "runner failed",
    "scope": "scope",
    "writingQualityCheck": "Writing Quality Check",
    "internalRequirementCheck": "Internal Requirement Check",
    "scoreOutOf": "{{score}}%",
    "itemScore": "{{score}}/{{weight}}",
    "sectionNotRequested": "Not requested",
    "sectionNotRequestedNote": "This check was not enabled for this run, so it did not run. This is not a clean result.",
    "requirementNotRequestedNote": "Not requested — no template document was uploaded, so no requirement checklist was derived and this check did not run. This is not a clean result.",
    "sectionFailed": "This check did not complete",
    "sectionFailedReason": {
      "checklist_not_derived": "No requirements could be drawn from the template you uploaded, so there was nothing to check this document against. Upload a template that states its requirements as explicit clauses, then run the check again.",
      "checklist_too_large": "The template produced more requirements than one run can check this document against. Narrow it to the sections that matter here, or split it across several runs.",
      "response_incomplete": "This check ran out of room before it finished reading, so its result would have covered only part of the document and was not shown. Try a shorter document, or split this one and run the parts separately.",
      "retrieval_unavailable": "This check could not reach the reference material it compares documents against, so it was stopped. Nothing is wrong with your document — try again shortly, and quote run {{jobId}} if it keeps happening.",
      "timed_out": "This check did not answer in time and was stopped. Run it again; a shorter document is less likely to run long. Quote run {{jobId}} if it happens twice.",
      "unknown": "The check stopped before producing a result, so nothing can be reported for it — not even that this document is clean. Run it again, and quote run {{jobId}} if it happens twice."
    },
    "runFailedTitle": "This review did not complete",
    "runFailedNote": "The run stopped before any check produced a result, so nothing can be reported for this document — not even that it is clean. Run it again, and quote run {{jobId}} if it happens twice.",
    "sectionUnreadable": "This section could not be read",
    "sectionUnreadableNote": "The run recorded a result in the current format, but this section is missing or malformed, so nothing can be reported for it. This is not a clean result.",
    "failedChip": "failed",
    "unreadableChip": "unreadable",
    "itemUnreadable": "This criterion could not be read",
    "itemUnreadableNote": "Its score, weight or findings are missing or malformed, so nothing can be reported for it. This is not a clean result.",
    "noItemFindings": "No findings for this criterion.",
    "checklistTitle": "Derived checklist",
    "checklistSource": "Derived from {{filename}}",
    "checklistWeight": "w{{weight}}",
    "checklistAnchor": "Template source: {{sourceRef}}",
    "checklistDerivedBy": "Derived by {{model}} · prompt set {{promptSetVersion}} · template SHA-256 {{templateSha256}}",
    "checklistNotRecorded": "not recorded",
    "checklistSourceUnrecorded": "The template this checklist was derived from was not recorded. This is not a clean result.",
    "checklistEntryUnreadable": "This checklist line could not be read",
    "checklistEntryUnreadableNote": "Its weight is missing or malformed, so it cannot be shown as part of the derived rubric and the weights above do not add up to the whole. This is not a clean result.",
    "checklistMissing": "The derived checklist was not recorded",
    "checklistMissingNote": "This check was scored, but the checklist it was scored against was not saved with the run, so the criteria cannot be traced back to the template.",
    "legacySchemaNote": "This run predates the current result format, so it has no overall verdict and no section scores. It is shown exactly as it was recorded.",
    "sectionStatesHint": "Writing quality: {{writing}} · Internal requirement: {{requirement}} · Regulatory: {{regulatory}}",
    "state_ok": "ran",
    "state_not_requested": "not requested",
    "state_failed": "failed",
    "state_unreadable": "unreadable",
    "verdictPassed": "Passed",
    "verdictPassedWithIssues": "Passed with issues",
    "verdictFailed": "Failed",
    "verdictWithheld": "no verdict",
    "verdictWithheldHint": "No overall verdict was recorded for this run, so it cannot be read as a pass. Open the run to see what each check reported.",
    "verdictUnreadable": "unreadable",
    "verdictUnreadableHint": "This run recorded an overall verdict in a form that cannot be read, so nothing can be reported for it. This is not a clean result.",
    "verdictLegacyHint": "This run predates the current result format, so no overall verdict was ever computed for it.",
    "resultUnreadable": "This result could not be read",
    "resultUnreadableNote": "The run reported success but recorded its result in a format Bennie does not recognise, so nothing can be reported about this document — not even that it is clean. Run it again, and quote run {{jobId}} if it happens twice.",
    "verdictNoResultHint": "This run recorded no result, so there is no overall verdict to report.",
    "verdictShapeUnreadableHint": "This run recorded its result in a format that cannot be read, so nothing can be reported for it. This is not a clean result."
  },
  "findingsTable": {
    "searchPlaceholder": "Search description, location, evidence…",
    "findingsCount_one": "{{count}} finding",
    "findingsCount_other": "{{count}} findings",
    "filteredOfTotal": "{{shown}} of {{total}}",
    "noFindingsMatchFilter": "No findings match the current filter.",
    "noFindingsDetected": "No findings detected.",
    "colSeverity": "Severity",
    "colCategory": "Category",
    "colLocation": "Location",
    "colDescription": "Description",
    "ariaExpand": "Expand",
    "ariaCollapse": "Collapse",
    "evidenceExcerpt": "Evidence excerpt",
    "citedAuthority": "Cited authority — {{framework}} {{reference}}",
    "ckRecord": "CK record: {{id}}",
    "filterLabel": "Filter {{label}}",
    "noValues": "No values.",
    "clear": "Clear",
    "severityVocabularyUnavailable": "Severity labels could not be loaded, so severities are shown as their stored values."
  },
  "recentJobs": {
    "noRunsYet": "No runs yet",
    "pastRunsHint": "Past runs will appear here after they finish."
  },
  "exportModal": {
    "title": "Export {{tool}} data to workspace",
    "intro": "Only workspaces that are still accepting data uploads will appear here.",
    "searchPlaceholder": "Search workspaces by name or id",
    "noWorkspacesMatch": "No workspaces match.",
    "unnamed": "(unnamed)",
    "eligibilityOpen": "Open",
    "eligibilityClosed": "Closed",
    "cancel": "Cancel",
    "refresh": "Refresh",
    "export": "Export",
    "createProject": "Create a new project",
    "chooseModel": "Choose a model",
    "createCheckFailed": "We couldn't check this — try again",
    "targetsFailed": "Your workspaces could not be loaded, so there is nothing to export to yet. Try again in a moment.",
    "importFailed": "The export did not complete, so nothing was sent to this workspace. Try again in a moment.",
    "ineligibility": {
      "archived": "This workspace is archived, so it can't take new data.",
      "model_archived": "The model this workspace belongs to is archived, so it can't take new data.",
      "no_workflow_state": "This workspace hasn't been set up yet.",
      "no_approved_plan": "Approve this workspace's plan first, then export into it.",
      "report_generation_started": "Report generation has started, so this workspace is no longer accepting new data.",
      "failed_state": "Resolve this workspace's failed step first, then export into it.",
      "workspace_busy": "This workspace is busy — wait for the current step to finish, then try again.",
      "workspace_terminal": "This workspace is marked complete, so it can't take new data.",
      "unknown_workflow_state": "We can't tell what stage this workspace is at, so it can't accept new data.",
      "auditing_import_requires_phase": "This workspace takes files per analysis phase — add them from its Design effective or Operating effective tab.",
      "default": "This workspace can't accept new data right now."
    }
  },
  "uploadedFilesTree": {
    "header": "Uploaded files"
  },
  "gatekeeper": {
    "title": "Submission Gatekeeper",
    "subtitle": "Submission-package intake check",
    "package": {
      "title": "1. Pick submission package",
      "help": "Mixed-format intake — .docx · .xlsx · .pdf · code files · .txt. Up to 200 files, 25 MB total per submission. Files that can't be read are flagged for manual review.",
      "dropHeadline": "Add the submission files",
      "filesButton": "Files",
      "folderButton": "Folder",
      "dropHint": "or drag-drop here",
      "queueMeta": "{{count}} file(s) · {{size}}",
      "clearAll": "Clear all",
      "tooManyFiles": "Too many files (max {{max}}). Remove some to continue.",
      "totalTooLarge": "Total size exceeds {{max}}. Remove some files to continue.",
      "fileTooLarge": "{{name}} exceeds {{max}}. Remove it to continue."
    },
    "template": {
      "title": "2. Pick submission template",
      "help": "Free-form checklist of what the package is supposed to contain. Paste text or upload a file in any format Bennie reads.",
      "paste": "Paste text",
      "upload": "Upload file",
      "pastePlaceholder": "List the artifacts and content the package should include — model file, validation report, test results, methodology notes, etc.",
      "dropLabel": "Click to choose any .docx · .pdf · .md · .txt file."
    },
    "knobs": {
      "title": "3. Configure run",
      "sampling": "Sampling depth",
      "samplingHelp": "How deeply each file is read",
      "sampling_sparse": "Sparse",
      "sampling_balanced": "Balanced",
      "sampling_dense": "Dense",
      "strictness": "Verdict strictness",
      "strictnessHelp": "How demanding the verdict step is",
      "strictness_loose": "Loose",
      "strictness_balanced": "Balanced",
      "strictness_strict": "Strict",
      "outputLanguage": "Output language",
      "outputLanguageHelp": "Verdict explanation language",
      "lang_en": "English",
      "lang_fr": "Français"
    },
    "runCta": "Run intake check",
    "submitting": "Submitting…",
    "submittingHint": "Queueing the intake check.",
    "statusLabel": {
      "completed": "Completed"
    },
    "recent": {
      "title": "Recent runs",
      "metaSuffix": "· this tool only · refresh 4s",
      "empty": "No completed runs yet.",
      "headerHeadline": "Run",
      "headerFinished": "Finished",
      "headerVerdict": "Verdict",
      "headerFiles": "Files",
      "headerDuration": "Duration",
      "headerStatus": "Status"
    },
    "fileLabel_one": "{{count}} file",
    "fileLabel_other": "{{count}} files",
    "verdict": {
      "pass": "PASS",
      "fail": "FAIL",
      "error": "Error",
      "cancelled": "Cancelled",
      "stale": "Stale",
      "passHeadline": "Package is enough to work with.",
      "failHeadline": "Critical artifacts are missing — package is not yet ready."
    },
    "risk": {
      "high": "High risk",
      "medium": "Medium risk",
      "low": "Low risk"
    },
    "run": {
      "title": "Intake run",
      "inProgress": "In progress",
      "filesProcessed": "Files processed",
      "starting": "Starting…",
      "preparing": "Preparing the package…",
      "skimProgress": "{{skimmed}} of {{total}} files skimmed",
      "processedSummary": "{{total}} files · {{ok}} read · {{attention}} flagged",
      "phaseExtracting": "Reading file contents",
      "phaseSkimming": "Skimming files",
      "phaseJudging": "Rendering verdict",
      "verdictPending": {
        "title": "Rendering verdict…",
        "subtitle": "Comparing the skim manifest against your submission template."
      },
      "phaseSkimComplete": "Skim complete",
      "phaseComplete": "Complete",
      "statusOk": "OK",
      "statusAttention": "Attention",
      "statusProcessing": "Processing",
      "statusPending": "Pending",
      "missingTitle": "Missing from package",
      "missingEmpty": "Nothing missing — package fully covers the template.",
      "attentionTitle": "Files flagged for manual review",
      "errorTitle": "Run could not complete",
      "runFailedTitle": "This gate did not complete",
      "runFailedNote": "The run stopped before it produced a verdict, so nothing can be reported about this package — not even that it is complete. Run it again, and quote run {{jobId}} if it happens twice.",
      "cancelledNote": "This run was cancelled.",
      "runAnother": "Run another package",
      "backToDashboard": "Back to toolbox",
      "pollFailed": "Could not refresh run status.",
      "statsFiles": "Files",
      "statsOk": "Skimmed",
      "statsAttention": "Attention",
      "completeTitle": "Gate complete",
      "exportToWorkspace": "Export to workspace"
    }
  },
  "filePicker": {
    "dropFileHere": "Drop a file here",
    "dropFilesHere": "Drop files here",
    "fileButton": "File",
    "filesButton": "Files"
  },
  "submitError": {
    "tooLarge": "This submission is larger than the {{max}} upload limit, so it could not be sent. Remove or split large files and try again.",
    "fileTooLarge": "{{name}} is larger than the {{max}} upload limit.",
    "totalTooLarge": "Total size exceeds the {{max}} upload limit. Remove some files to continue.",
    "generic": "The run could not be started. Please try again — if it keeps failing, contact support."
  },
  "download": {
    "session": "Your session has expired. Sign in again, then retry the download.",
    "notReady": "This run has not finished yet. Wait for it to complete, then download.",
    "missing": "There is no file to download for this run.",
    "timeout": "The download took too long and was stopped. Please try again.",
    "failed": "The download did not complete. Please try again."
  },
  "codeWalkthrough": {
    "exportToWorkspace": "Export to workspace",
    "title": "Code Walkthrough",
    "subtitle": "Line-anchored review workbook",
    "intro": "Produces an Excel workbook where every line of code is a row and every row carries an explicit disposition. Add a baseline version to review changes, and a validation report to carry its findings onto the lines they concern.",
    "stepCurrent": "Model code",
    "currentHint": "Drop the scripts, or a folder of them. Repo plumbing (.git, .venv) is left out.",
    "stepBaseline": "Compare against a baseline version",
    "baselineHint": "The earlier version of the same scripts. Matching files are compared automatically.",
    "stepReport": "Annotate using a validation report",
    "reportHint": "A validation report (.md, .docx, .pdf). Its points are carried onto the lines they concern.",
    "willProduce": "Will produce:",
    "mode": {
      "fullFile": "Full logic interpretation",
      "diff": "Change interpretation (diff)",
      "fullFileWithReport": "Annotated code, report-grounded",
      "diffWithReport": "Change interpretation, report-grounded"
    },
    "submitting": "Starting the walkthrough",
    "submittingHint": "Uploading files and queueing the job.",
    "runCta": "Build workbook",
    "recentRuns": "Recent runs",
    "noCompletedRuns": "No completed runs yet.",
    "colTarget": "Files",
    "colRows": "Rows",
    "colFinished": "Finished",
    "colDuration": "Duration",
    "colStatus": "Status",
    "running": "Building the workbook",
    "runningHint": "Annotating each file in turn ({{status}}).",
    "runFailedTitle": "This walkthrough did not complete",
    "runFailedNote": "The run stopped before it produced a workbook, so nothing can be reported about these files. Run it again, and quote run {{jobId}} if it happens twice.",
    "workbookReady": "Workbook ready",
    "complete": "Complete",
    "completeWithGaps": "Complete — review needed",
    "gapsExplainer": "The workbook generated in full. The amber marks above need a reviewer's eye before it goes out.",
    "chipFiles": "{{n}} files",
    "chipRows": "{{n}} rows",
    "chipTruncated": "{{n}} cells truncated",
    "downloadWorkbook": "Download workbook",
    "preparingDownload": "Preparing…",
    "chipChangedRows_one": "{{count}} changed line",
    "chipChangedRows_other": "{{count}} changed lines",
    "chipUnannotated_one": "{{count}} changed line not dispositioned",
    "chipUnannotated_other": "{{count}} changed lines not dispositioned",
    "chipUnannotatedInterpretation_one": "{{count}} line not dispositioned",
    "chipUnannotatedInterpretation_other": "{{count}} lines not dispositioned",
    "noBaselineSupplied": "No baseline was supplied, so nothing was compared — every line was interpreted on its own.",
    "chipUnplaced_one": "{{count}} report finding not mapped to code",
    "chipUnplaced_other": "{{count}} report findings not mapped to code",
    "chipDropped_one": "{{count}} comment could not be placed",
    "chipDropped_other": "{{count}} comments could not be placed",
    "chipCommentColumns_other": "{{count}} comment columns",
    "inputsHeading": "This run",
    "inputsComparedWith": "compared against {{file}}",
    "inputsInterpreted": "interpreted on its own",
    "inputsReport": "Validation report",
    "inputsUnmatchedBaselines": "Baseline files nothing was mapped to (ignored)",
    "mappingHeading": "Compare against",
    "mappingHint": "Pre-filled where the names obviously correspond — change any of it. Leave a row blank to review that file on its own; baselines nothing maps to are ignored.",
    "mappingNone": "— none, review on its own —",
    "mappingWillCompare": "change review",
    "mappingWillInterpret": "interpreted on its own",
    "mappingAriaFor": "Baseline for {{file}}"
  }
}
